import { useEffect, useState } from 'react';
import { convertStyle } from 'utils/Style';
import { ImgBadge } from 'utils/Images';
import { useMemberInfo } from 'utils/State';

import promotionStyle from '../style/Promotion.module.scss';
import missionStyle from '../style/MissionEvent.module.scss';
import BookpalLink from 'component/common/custom/BookpalLink';
import BookpalLazyLoadImage from 'component/common/custom/BookpalLazyLoadImage';
import useAlertModal from 'component/common/modal/useAlertModal';


const style = { ...promotionStyle, ...missionStyle };

function DpList({random, data, alert}){

    const memberInfo = useMemberInfo();

    const [show, setShow] = useState(true);
    const [_data, _setData] = useState(null);

    
    useEffect(()=>{

        // if(_data !== null){
        //     return;
        // }

        if(_data === null){
            if(Array.isArray(data) && data?.length > 0){
                // return false;
                if(random === true){
                    data.sort(()=>Math.random() - 0.5);
                }
                
                _setData([...data]);
            }
            
        }
    },[])

    if(_data === null || !Array.isArray(_data) || _data?.length <= 0){
        return false;
    }

    return (
        <>
            <div className={convertStyle(style, "missionTemplate")}>
                <p className={convertStyle(style, "listButton")}>
                    <button 
                        className={convertStyle(style, "button btn-04 color-btn-03-txt " + (!show?'active':''))}
                        onClick={()=>{
                            setShow(!show);
                        }}
                        >
                        미션 대상 작품 {show ? '접기':'펼쳐보기'}
                        {/* <span>{show ? '접기':'열기'}</span> */}
                    </button>
                </p>
                <div className={convertStyle(style, "template temp_list temp_list_type template_row " + (show?'':'hide'))}>
                    <div className={convertStyle(style, "list")}>
                        <ul>
                            {_data?.map((item, index)=>{
                                return (
                                    <li key={index}>
                                        <BookpalLink 
                                            to={"/content/"+item?.ct_type+"/"+item?.bid} 
                                            check={{
                                                view_type:memberInfo?.view_type,
                                                work_adult:item?.adult,
                                            }}
                                            alert={alert}
                                            >
                                            <div className="cover_img radius-xs">
                                                {item?.adult ? <p className="ic_adult badge_adult_normal"><img src="/images/ic_adult.svg" /></p> : null}
                                                
                                                {/* <img src={item?.cover} /> */}
                                                <BookpalLazyLoadImage 
                                                    adult={item?.adult}
                                                    adultswitch={memberInfo?.audit_switch}
                                                    defaulttype={"cover_logo"}
                                                    locktype={"cover_lock"}
                                                    src={item?.cover}
                                                    // style={defaultImageStyle}
                                                />


                                                <p className="ic_bottom badges_box">
                                                    {item?.badge_promotion !== "" ? <span className="ic_midnight radius-xs icon_badge"><img src={ImgBadge(item?.badge_promotion)} /></span> : null}
                                                    {item?.badge_new_up !== "" ? <span className="ic_up radius-xs icon_badge"><img src={ImgBadge(item?.badge_new_up)} /></span> : null}
                                                    {item?.badge_discount > 0 ? <span className="ic_discount radius-xs discount_10 icon_badge"><img src={ImgBadge(item?.badge_discount)} /></span> : null }
                                                </p>
                                            </div>
                                            <div className="info_txt spacing_04">
                                                {item?.genre_kor !== "" ? <div className="info">
                                                    <span className="color-txt-05 caption-02">{item?.genre_kor}</span>
                                                </div> : ""}
                                                <div className="title color-txt-normal title-book-02-m text_overflow2">{item?.title}</div>
                                                {item?.wr_nick !== "" ? <div className="writer color-txt-03 body-01 text_overflow">{item?.wr_nick}</div> : ""}
                                            </div>
                                        </BookpalLink>
                                    </li>
                                );
                            })}
                            
                        </ul>
                    </div>
                </div>
            </div>
            {/* <AlertModal /> */}
        </>
    )
}




export default DpList;